import { render } from "./WalletTitleDivider.vue?vue&type=template&id=124eb89e&scoped=true"
import script from "./WalletTitleDivider.vue?vue&type=script&lang=js"
export * from "./WalletTitleDivider.vue?vue&type=script&lang=js"

import "./WalletTitleDivider.vue?vue&type=style&index=0&id=124eb89e&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124eb89e"]])

export default __exports__